import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getDocuments } from '../../reducers/documents';
import DocumentViewer from './viewer';
import DocumentUploader from './uploader';
import { FormattedMessage } from 'react-intl';

class Document extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showUploaderDialogCallback: undefined
        };

        this.renderViewer = this.renderViewer.bind(this);
        this.renderManager = this.renderManager.bind(this);

        this.loadFilteredDocuments = this.loadFilteredDocuments.bind(this);
    }

    loadFilteredDocuments(onLoaded) {
        const { documentsLoaded, docType, id, ownerRole, role, getDocuments, excludedTypes } = this.props;
        if (documentsLoaded && onLoaded === undefined) {
            return;
        }

        const onComplete = response => {
            if (onLoaded) onLoaded(response);
        };

        const filter = d =>
            !d.archived && (!docType || (Array.isArray(d.doc_type) ? d.doc_type : [d.doc_type]).includes(docType)) && !excludedTypes.includes(d.doc_type);
        getDocuments(ownerRole ? ownerRole : role, onComplete, undefined, id, filter);
    }

    renderBug(bugMessage) {
        const { documents } = this.props;

        if (!documents || documents.length === 0) {
            return;
        }

        return (
            <div className="row section">
                <div className="col-xs-12">
                    <FormattedMessage {...bugMessage} tagName={'p'} />
                </div>
                <div className="col-xs-12">{this.renderViewer()}</div>
            </div>
        );
    }

    renderViewer() {
        const { view, remove, archive, upload, id, displayName, filteredProvidedDocuments } = this.props;
        if (!view) {
            return null;
        }

        return (
            <DocumentViewer
                id={id}
                view={view}
                remove={remove}
                archive={archive}
                upload={upload}
                configuredDisplayName={displayName}
                getDocuments={onLoaded => this.loadFilteredDocuments(onLoaded)}
                providedDocuments={filteredProvidedDocuments}
            />
        );
    }

    renderManager() {
        const { id, role, ownerRole, upload, docType, displayName, filteredProvidedDocuments } = this.props;
        if (!upload) {
            return null;
        }
        return (
            <DocumentUploader
                id={id}
                role={ownerRole ? ownerRole : role}
                upload={upload}
                docType={docType}
                displayName={displayName}
                providedDocuments={filteredProvidedDocuments}
                getDocuments={onLoaded => this.loadFilteredDocuments(onLoaded)}
            />
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { documentsLoaded } = this.props;
        const { loadExisting } = nextProps;
        if (!loadExisting && documentsLoaded) return;

        this.loadFilteredDocuments();
    }

    componentDidMount() {
        const { loadExisting, documentsLoaded } = this.props;
        if (!loadExisting && documentsLoaded) return;

        this.loadFilteredDocuments();
    }

    render() {
        const { documents, view } = this.props;
        if (!documents) {
            return null;
        }

        return (
            <React.Fragment>
                {view.bug ? this.renderBug(view.bug) : this.renderViewer()}
                {this.renderManager()}
            </React.Fragment>
        );
    }
}

Document.defaultProps = {
    id: undefined,
    docType: '',
    excludeDocTypes: undefined,
    loadExisting: true,
    ownerRole: undefined,
    view: true,
    upload: undefined,
    remove: undefined,
    archive: undefined,
    displayName: undefined,
    providedDocuments: undefined
};
Document.propTypes = {
    id: PropTypes.string.isRequired,
    docType: PropTypes.string,
    excludeDocTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    loadExisting: PropTypes.bool,
    ownerRole: PropTypes.object,
    view: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    upload: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    remove: PropTypes.bool,
    archive: PropTypes.bool,
    displayName: PropTypes.any,
    providedDocuments: PropTypes.array
};

const mapStateToProps = (state, props) => {
    const { excludeDocTypes, providedDocuments, docType } = props;
    const excluded = excludeDocTypes ? (typeof excludeDocTypes === 'string' ? [excludeDocTypes] : excludeDocTypes) : [];
    const filteredProvidedDocuments = providedDocuments
        ? providedDocuments.filter(d => !d.archived && (!docType || d.doc_type.includes(docType)) && !excluded.includes(d.doc_type))
        : undefined;
    const documents = filteredProvidedDocuments || (state.documents[props.id] ? state.documents[props.id].list : undefined);

    const documentsLoaded = providedDocuments ? true : state.documents[props.id] !== undefined;
    return {
        role: state.identity.role,
        documentsLoaded,
        documents,
        excludedTypes: excluded,
        filteredProvidedDocuments
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getDocuments
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Document);



// WEBPACK FOOTER //
// ./src/components/document/index.jsx